import { useEffect, useState } from 'react';

/**
 * Becomes true only if `active` stays true for `delayMs`.
 * `resetKey` restarts the timer (e.g. a new dataNodeId) even when `active` never dropped.
 */
export function useDelayedFlag(active: boolean, delayMs: number, resetKey?: string): boolean {
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    if (!active) {
      setDelayed(false);
      return;
    }

    setDelayed(false);
    const timeoutId = setTimeout(() => setDelayed(true), delayMs);
    return () => clearTimeout(timeoutId);
  }, [active, delayMs, resetKey]);

  return delayed;
}
